import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Box, Text, Button, Spinner } from "@ui-kit/components/index.es";
import { func, bool, string } from "prop-types";
import ReactHtmlParser from "react-html-parser";

import I18n from "pages/_components/I18n";
import * as i18n from "util/i18n";
import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { actions as settingsActions, selectors as settingsSelectors } from "reducers/settings";

function TermsAndConditionsV3Content({ dispatch, termsAndConditions, isFetching, fetchingDownload }) {
    useEffect(() => {
        dispatch(settingsActions.getTermsAndConditions());
    }, [dispatch]);

    const handleDownload = () => {
        if (termsAndConditions) {
            dispatch(loginActions.downloadDocumentRequest({ format: "pdf" }));
        } else {
            dispatch(loginActions.downloadDocumentI18n("pdf", "global.termsAndConditions.content"));
        }
    };

    const content = termsAndConditions ? (
        <div>{ReactHtmlParser(termsAndConditions)}</div>
    ) : (
        <I18n component="p" id="global.termsAndCondiciones.message" componentProps={{ className: "text-white" }} />
    );

    return (
        <Box column gap={24} w="100%" css={{ maxHeight: "50vh", overflowY: "auto" }}>
            <Text
                as="h2"
                variant="body"
                color="white"
                css={{ fontSize: 20, fontFamily: "inherit" }}
                componentProps={{ "data-testid": "terms-title" }}>
                <I18n id="login.step4.termsAndCondiciones.label" />
            </Text>
            <Box column gap={24} w="100%">
                {isFetching ? (
                    <Box flex align="center" justify="center" p={24}>
                        <Spinner size="large" color="text-inverse-color" />
                    </Box>
                ) : (
                    <>
                        <Text variant="body" color="white" component="div">
                            {content}
                        </Text>
                        <Button
                            w="100%"
                            icon="SendDown"
                            iconVariant="outline"
                            text={i18n.get("global.download")}
                            variant="solid"
                            color="primary"
                            rounded
                            withShadow
                            loading={fetchingDownload}
                            onClick={handleDownload}
                            aria-label={i18n.get("global.download")}
                        />
                    </>
                )}
            </Box>
        </Box>
    );
}

TermsAndConditionsV3Content.propTypes = {
    dispatch: func.isRequired,
    termsAndConditions: string,
    isFetching: bool.isRequired,
    fetchingDownload: bool.isRequired,
};

TermsAndConditionsV3Content.defaultProps = {
    termsAndConditions: null,
};

const mapStateToProps = (state) => ({
    termsAndConditions: settingsSelectors.getTermsAndConditions(state),
    isFetching: settingsSelectors.isFetching(state),
    fetchingDownload: loginSelectors.getFetchingDownload(state),
});

export default compose(connect(mapStateToProps))(TermsAndConditionsV3Content);
